import React from 'react'
import PropTypes from 'prop-types'
import SvgIcon from '@material-ui/core/SvgIcon'

const LinkIcon = ({ classes, ...props }) => {
  return (
    <SvgIcon
      classes={{
        root: 'svg-icon--twitter',
        ...classes
      }}
      {...props}>
      <path
        fillRule="evenodd"
        d="M8 8C6.93913 8 5.92172 8.42143 5.17157 9.17157C4.42143 9.92172 4 10.9391 4 12C4 13.0609 4.42143 14.0783 5.17157 14.8284C5.54301 15.1999 5.98396 15.4945 6.46927 15.6955C6.95457 15.8965 7.47471 16 8 16C8.55228 16 9 16.4477 9 17C9 17.5523 8.55228 18 8 18C7.21207 18 6.43185 17.8448 5.7039 17.5433C4.97595 17.2417 4.31451 16.7998 3.75736 16.2426C2.63214 15.1174 2 13.5913 2 12C2 10.4087 2.63214 8.88258 3.75736 7.75736C4.88258 6.63214 6.4087 6 8 6C8.55228 6 9 6.44772 9 7C9 7.55228 8.55228 8 8 8ZM15 7C15 6.44772 15.4477 6 16 6C16.7879 6 17.5681 6.15519 18.2961 6.45672C19.0241 6.75825 19.6855 7.20021 20.2426 7.75736C20.7998 8.31451 21.2417 8.97595 21.5433 9.7039C21.8448 10.4319 22 11.2121 22 12C22 12.7879 21.8448 13.5681 21.5433 14.2961C21.2417 15.0241 20.7998 15.6855 20.2426 16.2426C19.6855 16.7998 19.0241 17.2417 18.2961 17.5433C17.5681 17.8448 16.7879 18 16 18C15.4477 18 15 17.5523 15 17C15 16.4477 15.4477 16 16 16C16.5253 16 17.0454 15.8965 17.5307 15.6955C18.016 15.4945 18.457 15.1999 18.8284 14.8284C19.1999 14.457 19.4945 14.016 19.6955 13.5307C19.8965 13.0454 20 12.5253 20 12C20 11.4747 19.8965 10.9546 19.6955 10.4693C19.4945 9.98396 19.1999 9.54301 18.8284 9.17157C18.457 8.80014 18.016 8.5055 17.5307 8.30448C17.0454 8.10346 16.5253 8 16 8C15.4477 8 15 7.55228 15 7Z"
      />
      <path
        fillRule="evenodd"
        d="M7 12C7 11.4477 7.44772 11 8 11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H8C7.44772 13 7 12.5523 7 12Z"
      />
    </SvgIcon>
  )
}

LinkIcon.propTypes = {
  classes: PropTypes.object
}

export default LinkIcon
